export default "__VITE_ASSET__DTVQbyuK__"